import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { Trash } from "../icons";
import {
  readChatHistory,
  setActiveChatInHistory,
  addNewChatToHistory,
  removeChatFromHistory,
  getDisplayName,
} from "../../utils/chatHistoryStorage";
import "../../styles/chat.css";

function ChatHistorySidebarNav() {
  const { accounts } = useMsal();
  const userName = getDisplayName(accounts);
  const navigate = useNavigate();
  const [chatHistory, setChatHistory] = useState(() => readChatHistory(userName));

  const handleChatSelect = (chat) => {
    setActiveChatInHistory(chat.id, userName);
    navigate("/chat");
  };

  const handleNewChat = () => {
    addNewChatToHistory(userName);
    navigate("/chat");
  };

  const handleDeleteChat = (chatId) => {
    const chatToDelete = chatHistory.find((c) => c.id === chatId);
    if (!window.confirm(`Chat "${chatToDelete?.name}" wirklich löschen?`)) return;

    setChatHistory(removeChatFromHistory(chatId, userName));
  };

  return (
    <div className="chat-sidebar-content">
      <button className="chat-new-btn" onClick={handleNewChat}>
        + New Chat
      </button>

      <div className="chat-nav">
        <h3 className="chat-nav-title">Open Chats</h3>

        {chatHistory.map((chat) => (
          <div
            key={chat.id}
            className={`chat-history-item-wrapper ${chat.isActive ? "is-active" : ""}`}
          >
            <span onClick={() => handleChatSelect(chat)} className="chat-history-name">
              {chat.name}
            </span>

            <button
              className="chat-delete-btn"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteChat(chat.id);
              }}
              title="Chat löschen"
              aria-label="Chat löschen"
            >
              <Trash className="chat-delete-icon" aria-hidden="true" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChatHistorySidebarNav;
